import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';

import EmailIcon from '@material-ui/icons/Mail';
import PhoneIcon from '@material-ui/icons/Phone';

import Container from '../container/container';
import Typography from '../typography/typography';
import VerticalText from '../verticalText/verticalText';
import { mobileFirstMedia as media } from '../../config/theme';
import { footerMenu } from '../../config/navigation';
import {
  FooterBase,
  FooterGrid,
  NavigationArea,
  AddressArea,
  ContactArea,
  LogoArea,
  Logo,
  FooterSection,
  NavList,
  NavItem,
  ContactLink,
} from './styles';

const Footer = ({ ...rest }) => {
  const {
    prismicStronaKontakt: {
      data: {
        nazwa_firmy: companyName,
        adres_firmy: { html: addressHtml, text: addressString },
        kontakt_telefoniczny,
        sekretariat,
      },
    },
    file: {
      childImageSharp: { fluid },
    },
  } = useStaticQuery(query);

  const { telefon_1: phone1, telefon_2: phone2 } = kontakt_telefoniczny[0];

  const { email } = sekretariat[0];

  const phoneNumbers = (
    <>
      <Typography color="primary">KONTAKT</Typography>

      <NavList>
        <NavItem>
          <ContactLink
            href={`tel:${phone1}`}
            css={`
              color: ${({ theme }) => theme.colors.primary} !important;
            `}
          >
            <PhoneIcon />
            {phone1}
          </ContactLink>
        </NavItem>

        <NavItem>
          <ContactLink
            href={`tel:${phone2}`}
            css={`
              color: ${({ theme }) => theme.colors.primary} !important;
            `}
          >
            <PhoneIcon />
            {phone2}
          </ContactLink>
        </NavItem>

        <NavItem css="text-transform: none;">
          <ContactLink href={`mailto:${email}`}>
            <EmailIcon />
            {email}
          </ContactLink>
        </NavItem>
      </NavList>
    </>
  );

  return (
    <FooterBase {...rest}>
      <Container
        css={`
          @media (${media.m}) {
            padding-left: 130px;
          }

          @media (min-width: 1690px) {
            padding-left: 25px;
          }
        `}
      >
        <FooterGrid>
          <VerticalText text="KONTAKT" />

          <NavigationArea>
            <FooterSection>
              <Typography color="primary">OFERTA</Typography>

              <NavList>
                {footerMenu.map(({ label, title, path }) => (
                  <NavItem key={path}>
                    <Link to={path} title={title}>
                      {label}
                    </Link>
                  </NavItem>
                ))}
              </NavList>
            </FooterSection>
          </NavigationArea>

          <AddressArea>
            <FooterSection>
              <Typography color="primary">ADRES FIRMY</Typography>

              <NavList>
                <NavItem>{companyName}</NavItem>

                <NavItem css="text-transform: none;">
                  <a
                    href={`http://maps.google.com/maps?q=${addressString}`}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    dangerouslySetInnerHTML={{ __html: addressHtml }}
                  />
                </NavItem>
              </NavList>
            </FooterSection>
          </AddressArea>

          <ContactArea>
            <FooterSection>{phoneNumbers}</FooterSection>
          </ContactArea>

          <LogoArea>
            <Logo fluid={fluid} />
          </LogoArea>
        </FooterGrid>
      </Container>
    </FooterBase>
  );
};

const query = graphql`
  query {
    prismicStronaKontakt {
      data {
        nazwa_firmy
        adres_firmy {
          html
          text
        }
        sekretariat {
          email
        }
        kontakt_telefoniczny {
          telefon_1
          telefon_2
        }
      }
    }

    file(name: { eq: "promen-logo" }) {
      childImageSharp {
        fluid(maxWidth: 200) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;

export default React.memo(Footer);
